module.exports = __webpack_public_path__ + "img/heartbeatfamlogohalf.cc4a072d.png";